import { render, staticRenderFns } from "./headFeeDetailPriceEachMonth.vue?vue&type=template&id=2435f041&scoped=true&"
import script from "./headFeeDetailPriceEachMonth.vue?vue&type=script&lang=js&"
export * from "./headFeeDetailPriceEachMonth.vue?vue&type=script&lang=js&"
import style0 from "./headFeeDetailPriceEachMonth.vue?vue&type=style&index=0&id=2435f041&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2435f041",
  null
  
)

export default component.exports